"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fortunago": {
    "dc293c5e": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "skipSearch": false
    }],
    "alba-nuova": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c145c985": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "skipSearch": false
    }],
    "cappelletta": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40d82057": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "skipSearch": false
    }],
    "casa-guarnoni": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9ea5f51c": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "skipSearch": false
    }],
    "casa-perini": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "07d81e68": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "skipSearch": false
    }],
    "filinago": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e30777da": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "skipSearch": false
    }],
    "la-boatta": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "20b7dcd7": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "skipSearch": false
    }],
    "montebelleto": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "83a65edc": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "skipSearch": false
    }],
    "pezzetto": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7c1a656c": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "skipSearch": false
    }],
    "porino": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f72a4d60": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "skipSearch": false
    }],
    "villa-forita": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b008d15d": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "skipSearch": false
    }],
    "villa-galeazzi": [{
      "hkey": "d5d02213",
      "slug": "fortunago",
      "name": "Fortunago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;